// hooks/useClocks.js or useClocks.ts
import { useState, useEffect } from "react";
import { getClocks } from "../services/ClockAPI";

export function useClocks({ refreshInterval = 60000 } = {}) {
  const [clocks, setClocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchClocks = async () => {
    try {
      const data = await getClocks();
      setClocks(data);
      setError(null);
    } catch (err) {
      console.error("Failed to load clocks", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClocks();

    const interval = setInterval(fetchClocks, refreshInterval);
    return () => clearInterval(interval);
  }, []);

  return { clocks, loading, error, refetch: fetchClocks };
}
